"use strict";
import "src/decidim/forms/forms";
import "stylesheets/decidim/forms/forms.scss";
require.context("../images", true);
